import { gql } from '@apollo/client';

export const FILTERED_PORTAL_PEOPLE = gql`
  query FilteredPortalPeople($input: StakeholderFilter) {
    people: getPeopleForPortal(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          persalNumber
          nationalID
          institutions {
            id
            name
            emisNumber
          }
          primaryInstitution {
            id
            name
            emisNumber
          }
          grades {
            id
            value
            name
          }
          type {
            id
            name
          }
        }
        cursor
      }
    }
  }
`;
